import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ReCAPTCHA from 'react-google-recaptcha';
import { useLogin, useNotify } from 'react-admin';
import { useState } from 'react';
import { useEffect } from 'react';

const defaultTheme = createTheme();

export default function SignIn() {
  const login = useLogin();
  const notify = useNotify();

  const [captcha, setCaptcha] = useState();

  useEffect(()=> {
    setTimeout(() =>window.document.getElementById("username").focus(),500)
  }, [])

  const handleSubmit = e => {
      e.preventDefault();
      let username = window.document.getElementById("username").value
      let password = window.document.getElementById("password").value
      // will call authProvider.login({ email, password })
      login({username, password, captcha}).catch(() =>
          notify('Username/password non validi o captcha errato')
      );
  };
  
  function handleReCAPTCHAChange (value){
    setCaptcha(value)
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs" style={{backgroundColor: 'white', width: '100%', maxWidth: '100%'}}>
        <CssBaseline />
        <Box
          sx={{
            backgroundColor: 'white',
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Assistenza Muttin Login
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, maxWidth: '300px' }}>
            <TextField
              autoComplete='username'
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
            />
            <TextField
              autoComplete='current-password'
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
            />
            <ReCAPTCHA sitekey='6LfAQk8nAAAAANlWuituEwdsftC9aruBM9P5xm4S' onChange={handleReCAPTCHAChange}/>
            {
              captcha &&
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                ACCEDI
              </Button>
            }
            
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}